import {
  FETCH_CARE_ROUND_TYPE,
  FETCH_CARE_ROUND_TYPE_SUCCESS,
  FETCH_CARE_ROUND_TYPE_FAILURE,
  SEARCH_CARE_ROUND_TYPE,
  SEARCH_CARE_ROUND_TYPE_SUCCESS,
  SEARCH_CARE_ROUND_TYPE_FAILURE,
  ADD_CARE_ROUND_TYPE,
  ADD_CARE_ROUND_TYPE_SUCCESS,
  ADD_CARE_ROUND_TYPE_FAILURE,
  FETCH_CARE_ROUND_TYPE_ITEM,
  FETCH_CARE_ROUND_TYPE_ITEM_SUCCESS,
  FETCH_CARE_ROUND_TYPE_ITEM_FAILURE,
  EDIT_CARE_ROUND_TYPE,
  EDIT_CARE_ROUND_TYPE_SUCCESS,
  EDIT_CARE_ROUND_TYPE_FAILURE,
  DELETE_CARE_ROUND_TYPE,
  DELETE_CARE_ROUND_TYPE_SUCCESS,
  DELETE_CARE_ROUND_TYPE_FAILURE,
  SET_CARE_ROUND_TYPE_ADD_EDIT_MODAL,
} from "./constants";

export const fetchCareRoundType = (payload) => ({
  type: FETCH_CARE_ROUND_TYPE,
  payload,
});
export const fetchCareRoundTypeSuccess = (payload) => ({
  type: FETCH_CARE_ROUND_TYPE_SUCCESS,
  payload,
});
export const fetchCareRoundTypeFailure = (payload) => ({
  type: FETCH_CARE_ROUND_TYPE_FAILURE,
  payload,
});

export const searchCareRoundType = (payload) => ({
  type: SEARCH_CARE_ROUND_TYPE,
  payload,
});
export const searchCareRoundTypeSuccess = (payload) => ({
  type: SEARCH_CARE_ROUND_TYPE_SUCCESS,
  payload,
});
export const searchCareRoundTypeFailure = (payload) => ({
  type: SEARCH_CARE_ROUND_TYPE_FAILURE,
  payload,
});

export const addCareRoundType = (payload) => ({
  type: ADD_CARE_ROUND_TYPE,
  payload,
});
export const addCareRoundTypeSuccess = (payload) => ({
  type: ADD_CARE_ROUND_TYPE_SUCCESS,
  payload,
});
export const addCareRoundTypeFailure = (payload) => ({
  type: ADD_CARE_ROUND_TYPE_FAILURE,
  payload,
});

export const fetchCareRoundTypeItem = (payload) => ({
  type: FETCH_CARE_ROUND_TYPE_ITEM,
  payload,
});
export const fetchCareRoundTypeItemSuccess = (payload) => ({
  type: FETCH_CARE_ROUND_TYPE_ITEM_SUCCESS,
  payload,
});
export const fetchCareRoundTypeItemFailure = (payload) => ({
  type: FETCH_CARE_ROUND_TYPE_ITEM_FAILURE,
  payload,
});

export const editCareRoundType = (payload) => ({
  type: EDIT_CARE_ROUND_TYPE,
  payload,
});
export const editCareRoundTypeSuccess = (payload) => ({
  type: EDIT_CARE_ROUND_TYPE_SUCCESS,
  payload,
});
export const editCareRoundTypeFailure = (payload) => ({
  type: EDIT_CARE_ROUND_TYPE_FAILURE,
  payload,
});

export const deleteCareRoundType = (payload, onDelete) => ({
  type: DELETE_CARE_ROUND_TYPE,
  payload,
  onDelete,
});
export const deleteCareRoundTypeSuccess = (payload) => ({
  type: DELETE_CARE_ROUND_TYPE_SUCCESS,
  payload,
});
export const deleteCareRoundTypeFailure = (payload) => ({
  type: DELETE_CARE_ROUND_TYPE_FAILURE,
  payload,
});

export const setCareRoundTypeAddEditModal = (payload) => ({
  type: SET_CARE_ROUND_TYPE_ADD_EDIT_MODAL,
  payload,
});
